import { AudioContext, FileLoader, Loader } from 'three';
import { LoadingManager } from 'three/src/loaders/LoadingManager';

class AudioLoader extends Loader
{

  constructor(manager?: LoadingManager)
  {

    super(manager);

  }

  load(url: string, onLoad: (buff: AudioBuffer | string) => void, onProgress?: (v: ProgressEvent) => void, onError?: (err: ErrorEvent) => void): void
  {
    const loader = new FileLoader(this.manager);
    loader.setResponseType('arraybuffer');
    loader.setPath(this.path);
    loader.setRequestHeader(this.requestHeader);
    loader.setWithCredentials(this.withCredentials);
    loader.load(url, (buffer: ArrayBuffer | string) =>
    {

      // Create a copy of the buffer. The `decodeAudioData` method
      // detaches the buffer when complete, preventing reuse.
      const bufferCopy = (buffer as ArrayBuffer).slice(0);

      const context = AudioContext.getContext();
      context.decodeAudioData(bufferCopy).then((audioBuffer) =>
      {
        onLoad(audioBuffer);
      }).catch(e => {
        if (onError) {
          onError(e);
        }
        else {
          console.error(e);
        }

        this.manager.itemError(url);
      });

    }, onProgress, onError);
  }

}


export { AudioLoader };
